import { CheckCircleOutlined, WarningOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const WarningIcon = styled(WarningOutlined)`
  color: red;
`;

export const SuccessIcon = styled(CheckCircleOutlined)`
  color: green;
`;
